function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2571",
  "data-name": "Group 2571",
  transform: "translate(-279.784 74.125)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3662",
  "data-name": "Path 3662",
  d: "M342.773-29.075l.214.214c1.045,1.057,1.053,1.251.086,2.395-.1.115-.212.214-.323.325a8.431,8.431,0,0,0-4.248.989c-.686.414-1.385.783-2.079,1.174a6.611,6.611,0,0,1-3.405.882c-.352,0-.705-.025-1.054,0a8.583,8.583,0,0,1-5.439-1.424c-.358-.229-.718-.454-1.069-.692a6.44,6.44,0,0,0-2.537-.778,5.851,5.851,0,0,0-2.557.1,11.78,11.78,0,0,0-3.181,1.453,7.989,7.989,0,0,1-4.417,1.339,17.372,17.372,0,0,0-2.259.006,5.24,5.24,0,0,1-2.862-.74,9.047,9.047,0,0,1-2.323-1.341,3.352,3.352,0,0,0-1.414-.552c-2.809-.771-4.149-.434-6.622,1.041a9.05,9.05,0,0,1-4.773,1.581c-.8-.008-1.609-.037-2.41.008a6.217,6.217,0,0,1-2.2-.52,15.735,15.735,0,0,1-2.761-1.334,7.942,7.942,0,0,0-3.888-1.171,1.405,1.405,0,0,1-1.326-1.026,1.323,1.323,0,0,1,.41-1.723,1.25,1.25,0,0,1,.492-.257,9.108,9.108,0,0,1,6.148,1.523,7.977,7.977,0,0,0,5.409,1.48,12.579,12.579,0,0,0,3.488-1.4,8.255,8.255,0,0,1,4.906-1.616c.753.013,1.507,0,2.26,0a12.779,12.779,0,0,1,2.71.73c.769.451,1.55.906,2.319,1.331a6.953,6.953,0,0,0,6.575.338c.8-.378,1.49-1.032,2.313-1.323,1.228-.436,2.364-1.241,3.776-1.086a9.551,9.551,0,0,0,1.656,0,9.353,9.353,0,0,1,5.568,1.838,8.791,8.791,0,0,0,5.387,1.183c.692-.6,1.7-.448,2.419-1.116.549-.506,1.512-.549,2.1-1.029a4.9,4.9,0,0,1,2.1-.767A12.12,12.12,0,0,1,342.773-29.075Z",
  transform: "translate(0 -33.504)",
  fill: "#a64daa"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3663",
  "data-name": "Path 3663",
  d: "M419.047-5.09c2.594-.223,4.983,2.475,4.911,4.885a5.016,5.016,0,0,1-4.881,5.041A5.157,5.157,0,0,1,414.01-.188,5.029,5.029,0,0,1,419.047-5.09Zm1.592,4.071c-.2-.2-.37-.394-.562-.555a2.861,2.861,0,0,0-1.345-.251c-1.3.366-1.515.661-1.41,1.925a1.6,1.6,0,0,0,1.558,1.449,1.514,1.514,0,0,0,1.751-1.4A9.57,9.57,0,0,0,420.639-1.019Z",
  transform: "translate(-93.749 -50.305)",
  fill: "#a64daa"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3664",
  "data-name": "Path 3664",
  d: "M458.929-.067c-.266-2.6,2.437-5.163,4.821-5.062a5.012,5.012,0,0,1,5.071,4.841A4.331,4.331,0,0,1,467.1,3.5a5.042,5.042,0,0,1-3.369,1.319,4.183,4.183,0,0,1-3.28-1.415C459.587,2.474,458.679,1.356,458.929-.067Zm3.309-.975a5.959,5.959,0,0,1-.01,1.049c-.144.79.3,1.131.932,1.388a1.661,1.661,0,0,0,2.4-1.6,2.056,2.056,0,0,0-.757-1.58H462.99Z",
  transform: "translate(-125.095 -50.284)",
  fill: "#a64daa"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3665",
  "data-name": "Path 3665",
  d: "M379.072-.067a4.844,4.844,0,0,1-4.869,4.9,4.588,4.588,0,0,1-3.76-1.8,4.92,4.92,0,0,1-1.263-3.362A5.061,5.061,0,0,1,374.3-5.105,4.852,4.852,0,0,1,379.072-.067ZM372.41.216l1.251,1.326h1.3c1.383-1.083,1.435-2.124.061-3.3C372.99-2.034,372.238-1.17,372.41.216Z",
  transform: "translate(-62.434 -50.303)",
  fill: "#a64daa"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3666",
  "data-name": "Path 3666",
  d: "M279.985-.208a4.837,4.837,0,0,1,4.908-4.9A4.917,4.917,0,0,1,289.863-.2c-.19,3.106-2.257,5.086-5.147,5A4.718,4.718,0,0,1,279.985-.208Zm6.634.685c.185-1.943-.75-2.428-2.543-2.254-1.374,1.161-1.409,2.1-.022,3.316h1.512Z",
  transform: "translate(-0.136 -50.3)",
  fill: "#a64daa"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3667",
  "data-name": "Path 3667",
  d: "M334.566-.181c.363,3.051-2.492,4.965-4.8,5.029A4.91,4.91,0,0,1,326.2,3.308a4.681,4.681,0,0,1-1.311-3.686,4.571,4.571,0,0,1,1.5-3.309,4.493,4.493,0,0,1,3.342-1.388,4.454,4.454,0,0,1,3.355,1.361A4.089,4.089,0,0,1,334.566-.181ZM331.553-.71l-1.1-1.037h-1.471l-1.032,1.1a2.391,2.391,0,0,0,1.04,2.21h1.5A2.474,2.474,0,0,0,331.553-.71Z",
  transform: "translate(-31.506 -50.325)",
  fill: "#a64daa"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3668",
  "data-name": "Path 3668",
  d: "M310.354,35.577c-1.748.243-2.865-1.092-3.354-3.165.3-1.112.363-2.263,1.652-2.929a3.8,3.8,0,0,1,3.415-.256,3.73,3.73,0,0,1,1.823,2.287,3.077,3.077,0,0,1-.31,2.387,4.487,4.487,0,0,1-1.356,1.361C311.693,35.706,311.023,35.545,310.354,35.577Z",
  transform: "translate(-19.009 -74.078)",
  fill: "#a64daa"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3669",
  "data-name": "Path 3669",
  d: "M355.387,35.507a2.4,2.4,0,0,1-2.187-.744,3.832,3.832,0,0,1-1.2-2.51,3.7,3.7,0,0,1,1.128-2.537,2.727,2.727,0,0,1,2.208-.859,3.811,3.811,0,0,1,2.595,1.005,2.837,2.837,0,0,1,.957,2.278C358.792,33.873,357.624,35.831,355.387,35.507Z",
  transform: "translate(-50.438 -74.023)",
  fill: "#a64daa"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3670",
  "data-name": "Path 3670",
  d: "M403.537,32.188a2.474,2.474,0,0,1-.849,2.487,3.064,3.064,0,0,1-2.361.863,3.433,3.433,0,0,1-2.453-1.041,3.266,3.266,0,0,1,.019-4.653,3.2,3.2,0,0,1,2.31-1.012,3.382,3.382,0,0,1,2.495.88A2.435,2.435,0,0,1,403.537,32.188Z",
  transform: "translate(-81.807 -74.005)",
  fill: "#a64daa"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3671",
  "data-name": "Path 3671",
  d: "M445.241,28.918a2.482,2.482,0,0,1,2.32.923,3.076,3.076,0,0,1,1.021,2.3,3.159,3.159,0,0,1-1.032,2.45,3.252,3.252,0,0,1-2.328.962,3.317,3.317,0,0,1-2.3-5.718A2.48,2.48,0,0,1,445.241,28.918Z",
  transform: "translate(-113.221 -74.035)",
  fill: "#a64daa"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3672",
  "data-name": "Path 3672",
  d: "M379.991,51.943l1.026-1.026a2.236,2.236,0,0,1,2.009.522,2.644,2.644,0,0,1,.538,1.26c.09.61-1.139,1.854-1.781,1.805-.349-.027-.647-.36-1.073-.311-.123.014-.319-.236-.413-.4A2.829,2.829,0,0,1,379.991,51.943Z",
  transform: "translate(-69.964 -89.419)",
  fill: "#a64daa"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3673",
  "data-name": "Path 3673",
  d: "M338.62,53.311,336.812,54.7l-1.818-1.376c.028-1.73.751-2.28,1.8-2.347C337.927,50.9,338.544,51.706,338.62,53.311Z",
  transform: "translate(-38.561 -89.471)",
  fill: "#a64daa"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3674",
  "data-name": "Path 3674",
  d: "M428.288,51.922c.185,1.105-.02,2.039-1.227,2.445-.979.329-1.484-.4-2.062-.947v-1.5l.993-1.007C427.118,50.562,427.73,51.212,428.288,51.922Z",
  transform: "translate(-101.427 -89.361)",
  fill: "#a64daa"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_562",
  "data-name": "Line 562",
  x2: 64,
  transform: "translate(280.285 -72.625)",
  fill: "none",
  stroke: "#a64daa",
  strokeWidth: 3
}));

var SvgNormalSkinFeelIcon = function SvgNormalSkinFeelIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64.501,
    height: 39.355,
    viewBox: "0 0 64.501 39.355",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNormalSkinFeelIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/normalSkinFeel-icon.5bbfef51.svg";
export { ForwardRef as ReactComponent };